/**
 * April Tax Integration Configuration
 * Documentation: https://developer.getapril.com/docs/fully-hosted-integration
 */
import { isProduction } from '@/config/environment';

// Application types for April Tax services
export type AprilApplication = 'FILING' | 'PAYCHECK_ESTIMATION' | 'PAYCHECK_OPTIMIZATION';

interface AprilConfig {
  baseUrl: string;
  partnerId: string;
}

// Environment-specific configuration
const getAprilConfig = (): AprilConfig => {
  if (isProduction) {
    return {
      baseUrl: 'https://tax.getapril.com',
      partnerId: '2fc204bd-e477-4e57-9ff6-1fa6e021df42',
    };
  } else {
    return {
      baseUrl: 'https://tax-sandbox.getapril.com',
      partnerId: '2fc204bd-e477-4e57-9ff6-1fa6e021df42',
    };
  }
};

/**
 * Generate April deep link URL
 * @param application - The tax application type (FILING, PAYCHECK_ESTIMATION, PAYCHECK_OPTIMIZATION)
 * @param partnerUserId - User's Cognito ID
 * @param email - User's email address
 * @returns The complete April deep link URL
 */
export const generateAprilDeepLink = (
  application: AprilApplication,
  partnerUserId: string,
  email: string,
): string => {
  const config = getAprilConfig();

  const params = new URLSearchParams({
    pihyeadb: config.partnerId, // Partner ID
    aiaofcla: application, // Application type
    pulkbetf: partnerUserId, // Partner User Identifier (Cognito ID)
    uemidloc: email, // Email (User Identifier)
  });

  return `${config.baseUrl}/?${params.toString()}`;
};

/**
 * Open April in a new tab
 */
export const openAprilInNewTab = (
  application: AprilApplication,
  partnerUserId: string,
  email: string,
): void => {
  const url = generateAprilDeepLink(application, partnerUserId, email);
  window.open(url, '_blank', 'noopener,noreferrer');
};

export default getAprilConfig;
